import AppLogo from 'src/assets/img/logo-gets.svg'
import React from 'react'

function Logo() {
  //return <img alt='GeTS Logo' src={AppLogo} className={'logo-gets'} />
  return <img alt='GeTS Logo' src='/na-mig/static/logo.jpg' className={'logo-gets'} style={{ height: '100%', width: '100%', maxWidth: '150px' }} />
}

export default Logo
